// extracted by mini-css-extract-plugin
export default {"rsl":"Testimonials_rsl__zki-q","rsl2":"Testimonials_rsl2__NvPqc","ih3h":"Testimonials_ih3h__DOGs+"};